exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._35peBHwJYomMLW{background-color:#97a0af;border-radius:3px;color:#fff;font-weight:700;margin-top:4px;overflow:hidden;padding:4px 8px;box-shadow:0 20px 32px -8px rgba(9,30,66,.25),0 0 0 1px rgba(9,30,66,.08)}._35peBHwJYomMLW._2xYv_BINjSW4NP{background-color:#fff;color:#172b4d}._35peBHwJYomMLW.YtbGURlAznAfbY{background-color:#ff9f1a;color:#172b4d}._35peBHwJYomMLW.Zfssbge8bAcxJD{background-color:#eb5a46}._35peBHwJYomMLW._1p4XJaA5hBFIGB,._35peBHwJYomMLW._3U22ROm6wMF7Tt{background-color:#61bd4f}", ""]);

// exports
exports.locals = {
	"appAlertItem": "_35peBHwJYomMLW",
	"neutral": "_2xYv_BINjSW4NP",
	"warning": "YtbGURlAznAfbY",
	"error": "Zfssbge8bAcxJD",
	"info": "_1p4XJaA5hBFIGB",
	"confirm": "_3U22ROm6wMF7Tt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/alert/alert.less
// module id = K01L
// module chunks = 24